var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('a',{staticClass:"search-result__link",attrs:{"href":_vm.hit.recipients[0].url}},[(this.hit._highlightResult)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.html)}}):_vm._e()]):_c('span',{domProps:{"innerHTML":_vm._s(_vm.html)}})
}
var staticRenderFns = []

export { render, staticRenderFns }